import React from 'react';
import './styles.css';

export interface CardDescriptionProps {
  variant?: 'text' | 'meta';
  maxLines?: number;
  className?: string;
  children: React.ReactNode;
}

const CardDescription: React.FC<CardDescriptionProps> = ({
  variant = 'text',
  maxLines = 2,
  className = '',
  children
}) => {
  const descriptionClassName = [
    'card-description',
    `card-description-${variant}`,
    className
  ].filter(Boolean).join(' ');

  const style = variant === 'text' ? {
    WebkitLineClamp: maxLines,
  } : undefined;

  return (
    <div className={descriptionClassName} style={style}>
      {children}
    </div>
  );
};

export default CardDescription; 